module.exports = __webpack_public_path__ + "static/media/chrome-icon.32d0b69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/chrome-icon.png
// module id = 1401
// module chunks = 0